{
  "ASSISTANT_NOT_CONFIGURED": "The assistant is not configured for this area yet",
  "ASSISTANT_CONVERSATION_NOT_FOUND": "Conversation not found",
  "ASSISTANT_CONVERSATION_DELETED": "Conversation deleted",
  "ASSISTANT_MESSAGE_REQUIRED": "Write a message or attach a file",
  "ASSISTANT_RUN_IN_PROGRESS": "The assistant is still replying in this conversation",
  "ASSISTANT_RUN_FAILED": "The assistant had a problem replying",
  "ASSISTANT_APPROVAL_NOT_PENDING": "This confirmation is no longer pending",
  "ASSISTANT_UPLOAD_NOT_FOUND": "File not found in this conversation",
  "ASSISTANT_UPLOAD_TYPE_INVALID": "File type not accepted",
  "ASSISTANT_UPLOAD_TOO_LARGE": "File is larger than allowed",
  "ASSISTANT_UPLOAD_INCOMPLETE": "The file has not finished uploading",
  "ASSISTANT_UPLOAD_NOT_RETRYABLE": "This file was already received",
  "ASSISTANT_UPLOAD_FAILED": "The file could not be processed"
}
